module.exports = __webpack_public_path__ + "img/L1060592.fc0f947c.jpg";